import { Box, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import {
  makeAllCustomerSummary,
  makeMemberBigSpenderSummary,
  makeMemberSummary,
  mapAllCustomerData,
  mapMemberBigSpender,
  mapMemberReport,
} from "../report-helper/member";
import {
  makeCategorySummary,
  makePaymentMethodSummary,
  makeProductSummary,
  makeTopBigspenderSummary,
  mapCategoryReport,
  mapPaymentMethodReport,
  mapProductReport,
  mapTopBigspenderReport,
} from "../report-helper/ranking";
import {
  makeCategoryinPCSummary,
  makeProductinPCSummary,
  makeSubcategoryinPCSummary,
  mapCategoryinPCReport,
  mapProductinPCReport,
  mapSubcategoryinPCReport,
} from "../report-helper/productandcategory";
import {
  makeGuestSummary,
  makeSummary,
  makeTransactionsSummary,
  makeVoidTransactionsSummary,
  mapGuestRevenueData,
  mapMemberRevenueData,
  mapTransactionData,
  mapVoidTransactionData,
} from "../report-helper/revenue";
import {
  makeRedeemSummary,
  makeRemainingSummary,
  makeTierSummary,
  makeTotalSummary,
  mapRedeemReport,
  mapRemainingReport,
  mapTierReport,
  mapTotalReport,
} from "../report-helper/loyalty";

import ActionBar from "../Share/ActionBar";
import CardTotal from "./../Share/CardTotal";
import DrawerComponent from "../../../../Dashboard/Dashboard-Component/DrawerComponent";
import Grid from "@material-ui/core/Grid";
import PermissionChecker from "../../../../../../components/PermissionChecker";
import SfBreadcrumbs from "../../../../../../components/SfBreadcrumbs";
import SuperFilterList from "./../Share/SuperFilterList";
import Table from "./../Share/Table";
import TableforPrint from "../Share/TableforPrint";
import { getDateTimeFormat } from "../../../../../../utils";
import { loadOneUser } from "../../../../../../hooks/useOneUser";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import useAllStat from "../../../../../../hooks/useAllStat";
import { useReactToPrint } from "react-to-print";

//import Button from "@material-ui/core/Button";



//import MockDataAllRevenue from "../../MockData/Revenue/MockDataAllRevenue.json";




//import settings from "../../../../../../utils/settings";












const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    bottom: 0,
    top: 0,
    right: 0,
    left: 0,
  },

  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {},

  RevenueByMember: {
    fontSize: "30px",
    color: "#FA9917",
    display: "flex",

    fontFamily: "MyriadPro",
    lineHeight: "35px",
  },
  Typography: {
    fontWeight: "bold",
    color: theme.orange,
    fontSize: 30,
    marginLeft: 45,
  },
  FilterAction: {
    display: "flex",
    justifyContent: "flex-end",
    height: 35,
  },
  pageButtonContainer: {
    display: "grid",
    gridTemplateColumns: "40px 80px 40px",
    alignItems: "center",
    justifyContent: "end",
    justifyItems: "center",
  },
}));

function GeneralRevenue({
  title,
  type,
  pageCatType = "revenue",
  selectedDate,
}) {
  const pageName = title;
  const componentRef = useRef();
  const [renderData, setRenderData] = useState(); //Use to render on screen
  const [allLoadedData, setAllLoadedData] = useState(); //Entire loaded data
  const [filter, setFilter] = useState();
  const [dateRange, setDateRange] = useState(selectedDate);
  const [selectedTier, setSelectedTier] = useState();
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedSubcategory, setSelectedSubcategory] = useState();
  const [selectedMemberType, setSelectedMemberType] = useState("all");
  const [selectedSortby, setSelectedSortby] = useState("price");
  const [selectedTierSortby, setSelectedTierSortby] = useState("all");
  const [selectedMemberSortby, setSelectedMemberSortby] = useState("member");

  const [page, setPage] = useState(0);
  const {
    getGuests,
    getMembers,
    getVoidTransactions,
    getTransactions,
    getAllRevenue,
    getTotalTransactions,
    getCategory,
    getBigspenderCondition,
    getFrequentCondition,
    getTiers,
    getProducts,
    // getProductsQTY,
    // getSubcategory,
    getProductDatas,
    getBigSpenders,
    getFrequentMembers,
    //getTotalEarn,
  } = useAllStat();

  //const { getMembers: getAllMembers } = useMembers();

  const filtersUsed = getUseFilters(pageCatType, type);

  const setRenderDatawithFilter = ({ report, ...rest }) => {
    setAllLoadedData({ ...report, ...rest });
    report.list = report.list.slice(page * 10, page * 10 + 10);
    setRenderData({ ...report, ...rest });
  };

  useEffect(() => {
    if (allLoadedData) {
      const { list, ...rest } = allLoadedData;
      // console.log(JSON.stringify(renderData));
      const data = { list: list };
      setRenderDatawithFilter({ report: data, ...rest });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    let fromDate = moment().format("YYYY-MM-DD");
    let toDate = moment().format("YYYY-MM-DD");
    let periodType = "Day";

    function manageFilter() {
      if (filter) {
        const selectedFilter = filter;
        if (!selectedFilter || selectedFilter === "All") {
          fromDate = "2020-01-01";
          toDate = moment().format("YYYY-MM-DD");
          periodType = "All";
        }
        if (selectedFilter === "Day") {
          fromDate = moment(dateRange.startDate).format("YYYY-MM-DD");
          toDate = moment(dateRange.startDate).format("YYYY-MM-DD");
          periodType = "Day";
        }
        if (selectedFilter === "Month") {
          fromDate = moment(dateRange.startDate)
            .startOf("Month")
            .format("YYYY-MM-DD");
          toDate = moment(dateRange.startDate)
            .endOf("Month")
            .format("YYYY-MM-DD");

          periodType = "Month";
        }
        if (selectedFilter === "Year") {
          fromDate = moment(dateRange.startDate).format("YYYY-01-01");
          toDate = moment(dateRange.startDate).format("YYYY-12-31");
          periodType = "Year";
        }
        if (selectedFilter === "Custom Date") {
          if (!dateRange) {
            return;
          }
          fromDate = moment(dateRange.startDate).format("YYYY-MM-DD");
          toDate = moment(dateRange.endDate).format("YYYY-MM-DD");
          periodType = "Day";
        }
      } else {
        fromDate = moment().format("YYYY-MM-DD");
        toDate = fromDate;
        periodType = "Day";
      }
    }

    async function fetchAllRevenue() {
      let summary = {};
      let report;
      let summarytier;
      if (type === "All") {
       
        const [members] = await getMembers({ fromDate, toDate, periodType });
     
        const [guests] = await getGuests({ fromDate, toDate, periodType });

        const guestsData = mapMemberRevenueData(
          filterEmptyPayment(guests),
          periodType
        ).filter((g) => g["Transactions"] > 0);

        console.time("map member");
        const membersData = mapMemberRevenueData(
          filterEmptyPayment(members),
          periodType
        ).filter((m) => m["Total Revenue"] !== 0);
        console.timeEnd("map member");
        report = {
          list: sortByName([...membersData, ...guestsData], periodType),
        };

        summarytier = [makeSummary(report.list)];
        summary["Total Revenue(THB)"] = summarytier[0]["Total Revenue"];
        summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Walk-in"] = guests?.reduce((total, g) => {
          return total + g.payment.total_transaction;
        }, 0);
        summary["Total Transactions"] = summarytier[0]["Transactions"];
        summary["Total Quantity (Unit)"] = summarytier[0]["Quantity (Units)"];
        console.timeEnd("Summary member");
      }
      if (type === "Member") {
        const [members] = await getMembers({ fromDate, toDate, periodType });
        const membersData = mapMemberRevenueData(
          filterEmptyPayment(members),
          periodType
        ).filter((m) => m["Total Revenue"] !== 0);
        report = {
          list:
            selectedMemberSortby === "member"
              ? sortByName(
                  membersData,
                  periodType
                ) /*sortbyDate([...membersData], periodType)*/
              : selectedMemberSortby === "item"
              ? sortByItem(membersData, periodType)
              : sortByRevenue(membersData, periodType),
        };
        summarytier = [makeSummary(report.list)];
        summary["Total Revenue(THB)"] = summarytier[0]["Total Revenue"];
        summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Transactions"] = summarytier[0]["Transactions"];
        summary["Total Quantity (Unit)"] = summarytier[0]["Quantity (Units)"];
      }
      if (type === "Guest") {
        const [guests] = await getGuests({ fromDate, toDate, periodType });
        const guestData = mapGuestRevenueData(
          filterEmptyPayment(guests),
          periodType
        );
        report = {
          list: sortbyDate(
            [...guestData].filter((g) => g["Transactions"] > 0),
            periodType
          ),
        };
        summarytier = [makeGuestSummary(report.list)];
        summary["Total Revenue(THB)"] = summarytier[0]["Total Revenue"];
        //summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Transactions"] = summarytier[0]["Transactions"];
        summary["Total Quantity (Unit)"] = summarytier[0]["Quantity (Units)"];
      }
      if (type === "Transactions") {
        let [guests] = await getTransactions({
          fromDate,
          toDate,
          periodType,
        });
        guests = guests?.filter((g) => g.status === "Complete");
        const datas = mapTransactionData(guests, periodType);
        report = {
          list: sortbyDate([...datas], "datetime"),
        };
        summarytier = [makeTransactionsSummary(report.list)];
        summary["Total Revenue(THB)"] = summarytier[0]["Total Payment"];
        //summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Cash"] = summarytier[0]["Cash"];
        summary["Total Transfer"] = summarytier[0]["Transfer"];
        summary["Total Credit/Debit"] = summarytier[0]["Credit/Debit"];
      }
      if (type === "Member's T") {
        let [members] = await getTransactions({
          fromDate,
          toDate,
          periodType,
          filter: "member",
        });
        members = members?.filter((g) => g.status === "Complete");

        const datas = mapTransactionData(members, periodType);
        report = {
          list: sortbyDate([...datas], "datetime"),
        };
        summarytier = [makeTransactionsSummary(report.list)];
        summary["Total Revenue(THB)"] = summarytier[0]["Total Payment"];
        //summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Cash"] = summarytier[0]["Cash"];
        summary["Total Transfer"] = summarytier[0]["Transfer"];
        summary["Total Credit/Debit"] = summarytier[0]["Credit/Debit"];
      }
      if (type === "Walkin's T") {
        let [guests] = await getTransactions({
          fromDate,
          toDate,
          periodType,
          filter: "guest",
        });
        guests = guests?.filter((g) => g.status === "Complete");
        const datas = mapTransactionData(guests, periodType);
        report = {
          list: sortbyDate([...datas], "datetime"),
        };
        summarytier = [makeTransactionsSummary(report.list)];
        summary["Total Revenue(THB)"] = summarytier[0]["Total Payment"];
        //summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Cash"] = summarytier[0]["Cash"];
        summary["Total Transfer"] = summarytier[0]["Transfer"];
        summary["Total Credit/Debit"] = summarytier[0]["Credit/Debit"];
      }
      if (type === "Void") {
        const [voids] = await getVoidTransactions({
          fromDate,
          toDate,
          periodType,
        });

        const datas = mapVoidTransactionData(voids, periodType);
        const dataswithName = await mapMerchantName(datas, "User");

        report = {
          list: sortbyDate([...dataswithName]),
        };
        summarytier = [makeVoidTransactionsSummary(report.list)];
        summary["Total Revenue(THB)"] = summarytier[0]["Total Revenue"];
        //summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Transactions"] = report.list.length;
      }

      setRenderDatawithFilter({ report, summary: summary, summarytier });
    }

    const fetchAllMember = async () => {
      let summary = {};
      let summaryTwoValues = [];
      let report;
      let summarytier;

      if (type === "Member") {
        let [members] = await getMembers({
          fromDate,
          toDate,
          periodType,
          filter:
            selectedTier && selectedTier !== "All"
              ? { tier: selectedTier }
              : null,
        });
        let fromAllDate = moment().subtract(100, "years").format("YYYY-MM-DD");
        let toAllDate = moment().format("YYYY-MM-DD");
        const [allMembers] = await getMembers({
          fromDate: fromAllDate,
          toDate: toAllDate,
          periodType: "All",
          allBranch: true,
        });
        //  let [membersWithPhone] = await getAllMembers();

        members = members?.map((m) => {
          const found = allMembers?.find((a) => a.member_id === m.member_id);

          if (found) {
            return {
              ...m,
              ltv: found.payment.total_revenue,
            };
          } else return { ...m, ltv: 0 };
        });

        const datas = mapMemberReport(
          members?.sort((a, b) => {
            if (a.firstname < b.firstname) {
              return -1;
            }
            if (a.firstname > b.firstname) {
              return 1;
            }
            return 0;
          })
        ) ?? [];

        report = {
          list: [...datas],
        };

        summarytier = [makeMemberSummary(report.list)];
        summary["Total Members"] = report.list.length;
        summary["Total LTV(THB)"] = summarytier[0]["LTV(THB)"];
        summary["Total Transactions"] = summarytier[0]["Total Transactions"];
        summary["Total Earn"] = summarytier[0]["Total Earn"];
      } else if (type === "Guest") {
        const [guests] = await getGuests({ fromDate, toDate, periodType });
        const guestData = mapGuestRevenueData(
          filterEmptyPayment(guests)?.filter(
            (g) =>
              g.payment.total_transaction && g.payment.total_transaction !== 0
          ),
          periodType
        );
        report = {
          list: sortbyDate([...guestData], periodType),
        };
        summarytier = [makeGuestSummary(report.list)];
        summary["Total Revenue(THB)"] = summarytier[0]["Total Revenue"];
        //summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Transactions"] = summarytier[0]["Transactions"];
        summary["Total Quantity (Unit)"] = summarytier[0]["Quantity (Units)"];
      } else if (type === "All") {
        const [members] = await getMembers({ fromDate, toDate, periodType });
        let fromAllDate = moment().subtract(100, "years").format("YYYY-MM-DD");
        let toAllDate = moment().format("YYYY-MM-DD");
        const [allMembers] = await getMembers({
          fromDate: fromAllDate,
          toDate: toAllDate,
          periodType: "All",
          allBranch: true,
        });

        let totalRevenue = 0;
        const memberswithLTV = members
          ?.map((m) => {
            const found = allMembers?.find((a) => a.member_id === m.member_id);
            if (found) {
              totalRevenue += found.payment.total_revenue ?? 0;
              return { ...m, ltv: found.payment.total_revenue };
            } else return { ...m, ltv: 0 };
          })
          .sort((a, b) => {
            if (a.firstname < b.firstname) {
              return -1;
            }
            if (a.firstname > b.firstname) {
              return 1;
            }
            return 0;
          });
        // .filter((m) => m.payment?.total_transaction)

        const [guests] = await getGuests({ fromDate, toDate, periodType });
        const guestsData = mapAllCustomerData(
          filterEmptyPayment(guests)?.filter(
            (g) =>
              g.payment?.total_transaction && g.payment?.total_transaction !== 0
          ),
          periodType
        );
        const membersData = mapAllCustomerData(memberswithLTV, periodType);
        report = {
          list: sortbyDate([...membersData, ...guestsData], periodType),
        };
        summarytier = [makeAllCustomerSummary(report.list)];
      
        summary["Total Members"] = members?.length ?? 0;

        summary["Total Walk-in"] = guests?.reduce((total, g) => {
          return total + g.payment.total_transaction;
        }, 0);
        summary["Total LTV (THB)"] = totalRevenue;
        summary["Total Revenues (THB)"] = summarytier[0]["Total Revenue"];
        summary["Total Transactions"] = summarytier[0]["Transactions"];
      } else if (type === "Bigspender") {
        const [bigSpenders] = await getBigSpenders({
          toDate,
        });

        let [members] = await getMembers({
          fromDate,
          toDate,
          periodType,
          filter:
            selectedTier && selectedTier !== "All"
              ? { tier: selectedTier }
              : null,
        });
        let fromAllDate = moment().subtract(100, "years").format("YYYY-MM-DD");
        let toAllDate = moment().format("YYYY-MM-DD");
        const [allMembers] = await getMembers({
          fromDate: fromAllDate,
          toDate: toAllDate,
          periodType: "All",
          allBranch: true,
        });

        members = filterEmptyPayment(
          members
            ?.map((m) => {
              const found = allMembers?.find(
                (a) => a.member_id === m.member_id
              );
              if (found) {
                return { ...m, ltv: found.payment.total_revenue };
              } else return { ...m, ltv: 0 };
            })
            .filter((m) => m.payment?.total_transaction)
            .sort((a, b) => b.ltv - a.ltv)
        );

        const filterdMember = members?.filter((member) => {
          return bigSpenders?.some((b) => {
            return b.phone === member.phone;
          }) || false;
        });

        //Find most frequent
        const mostFreqItemList = filterdMember?.map((member) => ({
          name: member.life_time.top_frequent_product?.name,
          frequent: member.life_time.top_frequent_product?.frequent,
          qty: member.life_time.top_frequent_product?.qty,
          amount: member.life_time.top_frequent_product?.amount,
        }));
        const tempItemList = [];

        mostFreqItemList?.forEach((item) => {
          const temp = tempItemList.find((t) => t.name === item.name);
          if (temp) {
            temp.frequent += item.frequent;
            temp.qty += item.qty;
            temp.amount += item.amount;
          } else {
            tempItemList.push(item);
          }
        });
        let mostFrequentNum = -1;
        let mostFrequentItemName = "";
        let mostFrequentItemValue = "";
        tempItemList?.forEach((i) => {
          if (i.frequent > mostFrequentNum) {
            mostFrequentNum = i.frequent;
            mostFrequentItemName = i.name;
            mostFrequentItemValue = i.amount;
          }
        });

        const membersData = mapMemberBigSpender(filterdMember, periodType);
        report = {
          list: [...membersData],
        };
        summarytier = [makeMemberBigSpenderSummary(report.list)];
        summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total LTV"] = summarytier[0]["LTV(THB)"];
        summary["Total Revenue (THB)"] = summarytier[0]["Total Revenue (THB)"];
        summary["Total Transactions"] = summarytier[0]["Transactions"];
        summaryTwoValues.push([
          mostFrequentItemName + " (Frequent)",
          "Freq. " + (mostFrequentNum === -1 ? "-" : mostFrequentNum),

          "Value " + mostFrequentItemValue,
        ]);
      } else if (type === "Frequent") {
        const [frequentMembers] = await getFrequentMembers({
          toDate,
        });

        const [members] = await getMembers({
          fromDate,
          toDate,
          periodType,
          filter:
            selectedTier && selectedTier !== "All"
              ? { tier: selectedTier }
              : null,
        });

        let fromAllDate = moment().subtract(100, "years").format("YYYY-MM-DD");
        let toAllDate = moment().format("YYYY-MM-DD");
        const [allMembers] = await getMembers({
          fromDate: fromAllDate,
          toDate: toAllDate,
          periodType: "All",
          allBranch: true,
        });

        let filterdMember = filterEmptyPayment(
          members
            ?.map((m) => {
              const found = allMembers?.find(
                (a) => a.member_id === m.member_id
              );
              if (found) {
                return {
                  ...m,
                  ltv: found.payment?.total_revenue,
                  lifetime_trans: found.payment?.total_transaction,
                };
              } else return { ...m, ltv: 0, lifetime_trans: 0 };
            })
            .filter((m) => m.payment?.total_transaction)
            .sort(
              (a, b) =>
                b.payment?.total_transaction - a.payment?.total_transaction
            )
        );

        filterdMember = filterdMember?.filter((member) =>
          frequentMembers?.some((f) => member.phone === f.phone)
        );
        //Find most frequent
        const mostFreqItemList = filterdMember?.map((member) => ({
          name: member.life_time.top_frequent_product?.name,
          frequent: member.life_time.top_frequent_product?.frequent,
          qty: member.life_time.top_frequent_product?.qty,
          amount: member.life_time.top_frequent_product?.amount,
        }));
        const tempItemList = [];

        mostFreqItemList?.forEach((item) => {
          const temp = tempItemList.find((t) => t.name === item.name);
          if (temp) {
            temp.frequent += item.frequent;
            temp.qty += item.qty;
            temp.amount += item.amount;
          } else {
            tempItemList.push(item);
          }
        });
        let mostFrequentNum = -1;
        let mostFrequentItemName = "";
        let mostFrequentItemValue = "";
        tempItemList?.forEach((i) => {
          if (i.frequent > mostFrequentNum) {
            mostFrequentNum = i.frequent;
            mostFrequentItemName = i.name;
            mostFrequentItemValue = i.amount;
          }
        });

        const membersData = mapMemberBigSpender(filterdMember, periodType);
        report = {
          list: [...membersData],
        };
        summarytier = [makeMemberBigSpenderSummary(report.list)];
        console.log(report.list.length);
        summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total LTV"] = summarytier[0]["LTV(THB)"];
        summary["Total Revenue (THB)"] = summarytier[0]["Total Revenue (THB)"];
        summary["Total Transactions"] = summarytier[0]["Transactions"];
        summaryTwoValues.push([
          mostFrequentItemName + " (Frequent)",
          "Freq. " + (mostFrequentNum === -1 ? "-" : mostFrequentNum),
          "Value " + mostFrequentItemValue,
        ]);
      } else alert(type);
      setRenderDatawithFilter({
        report,
        summary: summary,
        summarytier,
        summaryTwoValues,
      });
    };

    const fetchEachLoyalty = async () => {
      //For each tier report (eg. Gold report Silver report)
      let summary = {};
      let report;
      let summarytier;
      let summaryBoxes = [];
      let tierBox;

      let fromAllDate = moment().subtract(100, "years").format("YYYY-MM-DD");
      let toAllDate = moment().format("YYYY-MM-DD");
      let [members] = await getMembers({
        fromDate: fromAllDate,
        toDate: toAllDate,
        periodType: "All",
        filter: { tier: type.replace("tier-", "") },
      });

      members = members?.map((m) => {
        return {
          ...m,
          ltv: m.payment.total_revenue,
        };
      });

      const datas = mapMemberReport(filterEmptyPayment(members)).sort(
        (a, b) => {
          if (a.Name < b.Name) {
            return -1;
          }
          if (a.Name > b.Name) {
            return 1;
          }
          return 0;
        }
      );

      report = {
        list: [...datas],
      };

      summarytier = [makeMemberSummary(report.list)];
      summary["Total Members"] = report.list.length;
      summary["Total LTV(THB)"] = summarytier[0]["LTV(THB)"];
      summary["Total Transactions"] = summarytier[0]["Total Transactions"];
      summary["Total Earn"] = summarytier[0]["Total Earn"];
      setRenderDatawithFilter({
        report,
        summary: summary,
        summarytier,
        summaryBoxes,
        tierBox,
      });
    };

    const fetchAllLoyalty = async () => {
      let summary = {};
      let report;
      let summarytier;
      let summaryBoxes = [];
      let tierBox;

      if (type === "Total") {
        const [members] = await getMembers({
          fromDate,
          toDate,
          periodType,
          filter:
            selectedTier && selectedTier !== "All"
              ? { tier: selectedTier }
              : null,
        });

        report = {
          list: mapTotalReport(filterEmptyPayment(members))
            .filter((m) => m["Total Earn (points)"] > 0)
            .sort(
              (a, b) => b["Total Earn (points)"] - a["Total Earn (points)"]
            ),
        };

        summarytier = [makeTotalSummary(report.list)];
        const totalEarn = summarytier[0]["Total Earn (points)"];
        // const totalRedeem = summarytier[0]["Total Redeem (points)"];
        // if (totalEarn) {
        //   let tRedeem = !totalRedeem ? 0 : totalRedeem;
        //   // summary["Redeeming Rate"] =
        //   //   Math.abs((tRedeem * 100) / totalEarn).toFixed(2) + "%";
        // } else {
        //   // summary["Redeeming Rate"] = "-";
        // }
        summary["Total Earn (points)"] = totalEarn;
        summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Revenue (THB)"] = summarytier[0]["Total Revenue (THB)"];
      } else if (type === "Redeem") {
        const [members] = await getMembers({
          fromDate,
          toDate,
          periodType,
          filter:
            selectedTier && selectedTier !== "All"
              ? { tier: selectedTier }
              : null,
        });

        const filterdMember = filterEmptyPayment(
          members?.filter((m) => {
            if (m.payment.total_redeem?.reward === 0) return false;
            else return true;
          })
        );
        report = {
          list: mapRedeemReport(
            filterdMember.sort(
              (a, b) =>
                a.payment.total_redeem?.reward - b.payment.total_redeem?.reward
            )
          ),
        };

        summarytier = [makeRedeemSummary(report.list)];

        // const totalRedeem = summarytier[0]["Total Redeem (points)"];
        // const totalEarn = summarytier[0]["Total Earn (points)"];
        summary["Total Redeem (points)"] =
          summarytier[0]["Total Redeem (points)"];
        summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Revenue (THB)"] = summarytier[0]["Total Revenue (THB)"];
      } else if (type === "Remaining") {
        let fromDate = moment().subtract(100, "years").format("YYYY-MM-DD");
        let toDate = moment().format("YYYY-MM-DD");
        let periodType = "All";
        const [members] = await getMembers({
          fromDate,
          toDate,
          periodType,
          filter:
            selectedTier && selectedTier !== "All"
              ? { tier: selectedTier }
              : null,
        });

        report = {
          list: mapRemainingReport(filterEmptyPayment(members)).sort(
            (a, b) =>
              b["Total Remaining (points)"] - a["Total Remaining (points)"]
          ),
        };

        summarytier = [makeRemainingSummary(report.list)];

        // const totalRedeem = summarytier[0]["Total Redeem (points)"];
        // const totalEarn = summarytier[0]["Total Earn (points)"];
        summary["Total Remaining (points)"] =
          summarytier[0]["Total Remaining (points)"];
        summary["Total Members"] = getNumUniqueMember(report.list);
        summary["Total Revenue (THB)"] = summarytier[0]["Total Revenue (THB)"];
      } else if (type === "Tiers") {
        let fromDate = moment().subtract(100, "years").format("YYYY-MM-DD");
        let toDate = moment().format("YYYY-MM-DD");
        let periodType = "All";
        const [tiers] = await getTiers();
        const [members] = await getMembers({ fromDate, toDate, periodType });
        const [bigSpenderValue] = await getBigspenderCondition();
        const [frequentValue] = await getFrequentCondition();
        const tiersWithNum = tiers.map((tier) => {
          members?.forEach((member) => {
            if (member.tier === tier.name) {
              tier.memberNum ? tier.memberNum++ : (tier.memberNum = 1);
              if (member?.payment?.total_payment >= bigSpenderValue) {
                tier.bigSpenderNum
                  ? tier.bigSpenderNum++
                  : (tier.bigSpenderNum = 1);
              }
              if (member?.payment?.total_transaction >= frequentValue) {
                tier.frequentNum ? tier.frequentNum++ : (tier.frequentNum = 1);
              }
              tier.revenue
                ? (tier.revenue += member?.payment?.total_revenue)
                : (tier.revenue = member?.payment?.total_revenue);
              tier.transactions
                ? (tier.transactions += member?.payment?.total_transaction)
                : (tier.transactions = member?.payment?.total_transaction);
              if (!tier.frequentCat) {
                tier.frequentCat = [];
              }
              if (member.life_time?.top_frequent_category?.name)
                tier.frequentCat.push(
                  member.life_time?.top_frequent_category?.name
                );
              if (!tier.frequentCat) {
                tier.frequentCat = [];
              }
              if (member.life_time?.top_frequent_category?.name)
                tier.frequentCat.push(
                  member.life_time?.top_frequent_category?.name
                );
              if (!tier.frequentProduct) {
                tier.frequentProduct = [];
              }
              if (member.life_time?.top_frequent_product?.name)
                tier.frequentProduct.push(
                  member.life_time?.top_frequent_product?.name
                );

              if (!tier.expenseCat) {
                tier.expenseCat = [];
              }
              if (member.life_time?.top_expense_category?.name)
                tier.expenseCat.push(
                  member.life_time?.top_expense_category?.name
                );
              if (!tier.expenseProduct) {
                tier.expenseProduct = [];
              }
              if (member.life_time?.top_expense_product?.name)
                tier.expenseProduct.push(
                  member.life_time?.top_expense_product?.name
                );
            }
          });

          return { ...tier };
        });

        if (selectedTierSortby === "ltv") {
          tiersWithNum.sort((a, b) => (b.revenue ?? 0) - (a.revenue ?? 0));
        } else if (selectedTierSortby === "bigspender") {
          tiersWithNum.sort(
            (a, b) => (b.bigSpenderNum ?? 0) - (a.bigSpenderNum ?? 0)
          );
        }
        report = {
          list: mapTierReport(tiersWithNum),
        };

        summarytier = [makeTierSummary(report.list)];
        summaryBoxes.push({
          title: "Total Member",
          titleValue: summarytier[0]["Members"],
          list: [
            { label: "Revenue (THB)", value: summarytier[0]["Revenue"] },
            {
              label: "Transactions (THB)",
              value: summarytier[0]["Transactions"],
            },
          ],
        });
        tierBox = {
          headers: [
            " ",
            ...report.list.map(
              (tier) => tier.name + ":" + (tier["Members"] ?? 0)
            ),
          ],
          list: [
            ["Revenue", ...report.list.map((tier) => tier["Revenue"] ?? 0)],
            [
              "Transactions",
              ...report.list.map((tier) => tier["Transactions"] ?? 0),
            ],
          ],
        };
      } else alert(type);

      setRenderDatawithFilter({
        report,
        summary: summary,
        summarytier,
        summaryBoxes,
        tierBox,
      });
    };

    const fetchAllProduct = async () => {
      let summary = {};
      let report;
      let summarytier;
      let walkIn = 0;
      if (type === "Product") {
        let datas;
        if (selectedMemberType === "member") {
          const [products] = await getMembers({
            fromDate,
            toDate,
            periodType,
          });
          datas = filterEmptyPayment(products);
        } else if (selectedMemberType === "guest") {
          const [products] = await getGuests({
            fromDate,
            toDate,
            periodType,
          });
          datas = filterEmptyPayment(products);
        } else {
          let [a] = await getMembers({
            fromDate,
            toDate,
            periodType,
          });
          let [b] = await getGuests({
            fromDate,
            toDate,
            periodType,
          });

          if (!a) a = [];
          if (!b) b = [];
          datas = [...filterEmptyPayment(a), ...filterEmptyPayment(b)];
        }

        report = {
          list: mapProductinPCReport(datas, selectedProduct).sort((a, b) => {
            if (a["Name"] < b["Name"]) {
              return -1;
            }
            if (a["Name"] > b["Name"]) {
              return 1;
            }
            return 0;
          }),
        };

        walkIn = report.list?.reduce((total, l) => {
          if (l["Name"] === "Walk-in") {
            return total + l["Transactions"];
          } else return total;
        }, 0);

        summarytier = [makeProductinPCSummary(report.list)];
        summary["Total Price (THB)"] = summarytier[0]["Total Price (THB)"];
        summary["Total Members"] = report.list.filter(
          (l) => l.Name !== "Walk-in"
        ).length;
        summary["Total Walk-in"] = walkIn;
        summary["Total Quantity"] = summarytier[0]["Total Quantity (units)"];
      } else if (type === "Category") {
        const [productStat] = await getProducts({
          fromDate,
          toDate,
          periodType,
        });

        if (!selectedCategory) {
          report = {list: []}
          summarytier = [[]];
          summary["Total Revenue (THB)"] = "";
          let columnName;
          if (selectedMemberType === "member") {
            columnName = "Total Member";
          } else if (selectedMemberType === "guest") {
            columnName = "Total Walk-in";
          } else {
            columnName = "Total Customer";
          }
          summary[columnName] = "";
          summary["Total Quantity (units)"] = "";
          summary["Total Transactions"] = "";
          
        }
        else {
        const [productDatas] = await getProductDatas({
          categoryId: selectedCategory,
        });

        const [members] = await getMembers({
          fromDate,
          toDate,
          periodType,
        });

        const productWithNumMembers =
          productDatas?.map((product) => {
            const totalMember =
              members?.reduce((total, current) => {
                if (
                  current.life_time?.total_product?.some(
                    (tp) => tp.product_id === product.id
                  )
                )
                  return total + 1;
                else return total;
              }, 0) ?? 0;
            return { ...product, totalMember: totalMember };
          }) ?? [];

        const productStatwithCat =
          productStat
            ?.filter((p) => {
              const data = productWithNumMembers?.find((pd) => {
                return pd.id === p.product_id;
              });
              return data;
            })
            ?.map((p) => {
              const data = productWithNumMembers?.find((pd) => {
                return pd.id === p.product_id;
              });

              return {
                ...p,
                code: data.code,
                categoryName: data.category.name,
                subcategoryName: data.sub_category.name,
                totalMember: data.totalMember,
              };
            }) ?? [];

        report = {
          list: mapCategoryinPCReport(
            productStatwithCat,
            selectedMemberType
          ).sort((a, b) => {
            if (a["Product Name"] < b.["Product Name"]) {
              return -1;
            }
            if (a["Product Name"] > b["Product Name"]) {
              return 1;
            }
            return 0;
          }),
        };

        summarytier = [
          makeCategoryinPCSummary(report.list, selectedMemberType),
        ];
        summary["Total Revenue (THB)"] = summarytier[0]["Total Revenue"];
        let columnName;
        if (selectedMemberType === "member") {
          columnName = "Total Member";
        } else if (selectedMemberType === "guest") {
          columnName = "Total Walk-in";
        } else {
          columnName = "Total Customer";
        }
        summary[columnName] = summarytier[0][columnName];
        summary["Total Quantity (units)"] =
          summarytier[0]["Total Quantity (units)"];
        summary["Total Transactions"] = summarytier[0]["Transactions"];
        }
      } else if (type === "Subcategory") {
        let [productStat] = await getProducts({
          fromDate,
          toDate,
          periodType,
        });
        if (!selectedSubcategory) {
          report = {list:[]}
          summarytier = [[]];
          summary["Total Revenue (THB)"] = "";
          let columnName;
          if (selectedMemberType === "member") {
            columnName = "Total Member";
          } else if (selectedMemberType === "guest") {
            columnName = "Total Walk-in";
          } else {
            columnName = "Total Customer";
          }
          summary[columnName] = "";
          summary["Total Quantity (units)"] = "";
          summary["Total Transactions"] = "";
         
        }
        else {
        const [productDatas] = await getProductDatas({
          subcategoryId: selectedSubcategory,
        });

        const [members] = await getMembers({
          fromDate,
          toDate,
          periodType,
        });

        const productWithNumMembers =
          productDatas?.map((product) => {
            const totalMember =
              members?.reduce((total, current) => {
                if (
                  current.life_time?.total_product?.some(
                    (tp) => tp.product_id === product.id
                  )
                )
                  return total + 1;
                else return total;
              }, 0) ?? 0;
            return { ...product, totalMember: totalMember };
          }) ?? [];

        const productStatwithCat =
          productStat
            ?.filter((p) => {
              const data = productWithNumMembers?.find((pd) => {
                return pd.id === p.product_id;
              });
              return data;
            })
            ?.map((p) => {
              const data = productWithNumMembers?.find((pd) => {
                return pd.id === p.product_id;
              });

              return {
                ...p,
                code: data.code,
                categoryName: data.category.name,
                subcategoryName: data.sub_category.name,
                totalMember: data.totalMember,
              };
            }) ?? [];

        report = {
          list: mapSubcategoryinPCReport(
            productStatwithCat,
            selectedMemberType
          ).sort((a, b) => {
            if (a["Product Name"] < b["Product Name"]) {
              return -1;
            }
            if (a["Product Name"] > b["Product Name"]) {
              return 1;
            }
            return 0;
          }),
        };

        summarytier = [
          makeSubcategoryinPCSummary(report.list, selectedMemberType),
        ];
        summary["Total Revenue (THB)"] = summarytier[0]["Total Revenue"];
        let columnName;
        if (selectedMemberType === "member") {
          columnName = "Total Member";
        } else if (selectedMemberType === "guest") {
          columnName = "Total Walk-in";
        } else {
          columnName = "Total Customer";
        }
        summary[columnName] = summarytier[0][columnName];
        summary["Total Quantity (units)"] =
          summarytier[0]["Total Quantity (units)"];
        summary["Total Transactions"] = summarytier[0]["Transactions"];
      }
      } else alert(type);
      setRenderDatawithFilter({ report, summary: summary, summarytier });
    };

    const fetchAllRanking = async () => {
      let summary = {};
      let summaryTwoValues = [];
      let summaryThreeValues = [];
      let report;
      let summarytier;
      if (type === "Payment") {
        const [revenues] = await getAllRevenue({
          fromDate,
          toDate,
          periodType,
        });
        const [trans] = await getTotalTransactions({
          fromDate,
          toDate,
          periodType,
        });

        const removedNullRevenue = mapPaymentMethodReport(
          revenues,
          trans
        ).filter((d) => d);
        const finalRevData = removedNullRevenue
          .sort((a, b) => b["Transactions"] - a["Transactions"])
          .map((ele, index) => ({ Ranking: index + 1, ...ele }));
        report = {
          list: finalRevData,
        };

        summarytier = [makePaymentMethodSummary(report.list)];

        // summary["Total Revenue (THB)"] = summarytier[0]["Total Revenue (THB)"];
        summaryThreeValues.push([
          "Total",
          "Transactions: " + summarytier[0]["Transactions"],
          "Revenue (THB): " + summarytier[0]["Total Revenue (THB)"],
        ]);

        report.list.forEach((data, index) => {
          if (index >= 3) return null;
          summaryThreeValues.push([
            `${index + 1}. ${data["Payment Method"]}`,
            `Transactions: ${data["Transactions"]}`,
            `Revenue (THB): ${data["Total Revenue (THB)"]}`,
          ]);
        });
        if (summaryThreeValues.length < 3) {
          const existingDataLength = summaryThreeValues.length;
          for (let i = 0; i < 4 - existingDataLength; i++) {
            summaryThreeValues.push([
              ` - `,
              `Transactions: 0`,
              `Revenue (THB): 0`,
            ]);
          }
        }
      } else if (type === "Product") {
        const [productQTY] = await getProducts({
          fromDate,
          toDate,
          periodType,
        });
        // alert(JSON.stringify(productQTY));
        const removedNullData = mapProductReport(
          productQTY,
          selectedMemberType
        ).filter((d) => d);
        let collectedData = [];
        //Custom date logic collect all Same data
        if(periodType === "Day" && fromDate !== toDate){
          //Accum all same data
          removedNullData.forEach(row => {
            
            const foundExistedIndex = collectedData.findIndex(collected => collected.product_id === row.product_id);
           
            if(foundExistedIndex > -1){
              collectedData[foundExistedIndex]["Total Price (THB)"] += row["Total Price (THB)"];
              collectedData[foundExistedIndex]["Quantity (units)"] += row["Quantity (units)"];
              collectedData[foundExistedIndex]["Transactions"] += row["Transactions"];
            }
            else collectedData.push(row)
          })
        }
        else collectedData = removedNullData;
        //Remove product id field
        collectedData = collectedData.map(c => {
          delete c.product_id;
          return c
        })

        const finalRevData = collectedData
          .sort((a, b) => {
            if (a["Product name"] > b["Product name"]) return 1;
            if (b["Product name"] > a["Product name"]) return -1;
            return 0;
          })
          .sort((a, b) => {
            if (selectedSortby === "price")
              return (
                Number(b["Total Price (THB)"]) - Number(a["Total Price (THB)"])
              );
            else
              return (
                Number(b["Quantity (units)"]) - Number(a["Quantity (units)"])
              );
          })
          .map((ele, index) => ({ Ranking: index + 1, ...ele }))
          .filter((t) => t["Transactions"] !== 0);

        report = {
          list: finalRevData,
        };

        summarytier = [makeProductSummary(report.list)];

        summaryThreeValues.push([
          "Total",
          "Transactions: " + summarytier[0]["Transactions"],
          "Price (THB): " + summarytier[0]["Total Price (THB)"],
          "Quantity (Units): " + summarytier[0]["Quantity (units)"],
        ]);

        report.list
          .filter((t) => t["Transactions"] !== 0)
          .forEach((data, index) => {
            if (index >= 3) return null;
            summaryThreeValues.push([
              `${index + 1}. ${data["Product name"]}`,
              `Transactions: ${data["Transactions"]}`,
              `Price (THB): ${data["Total Price (THB)"]}`,
              `Quantity (Units): ${data["Quantity (units)"]}`,
            ]);
          });
        if (summaryThreeValues.length < 3) {
          const existingDataLength = summaryThreeValues.length;
          for (let i = 0; i < 4 - existingDataLength; i++) {
            summaryThreeValues.push([
              ` - `,
              `Transactions: 0`,
              `Price (THB): 0`,
              `Quantity (Units): 0`,
            ]);
          }
        }
      } else if (type === "Category") {
        const [productQTY] = await getCategory({
          fromDate,
          toDate,
          periodType,
        });

        const removedNullData = mapCategoryReport(
          productQTY,
          selectedMemberType
        ).filter((d) => d);

        const finalRevData = removedNullData
          .sort((a, b) => {
            if (selectedSortby === "price")
              return (
                Number(b["Total Price (THB)"]) - Number(a["Total Price (THB)"])
              );
            else
              return (
                Number(b["Quantity (units)"]) - Number(a["Quantity (units)"])
              );
          })
          .map((ele, index) => ({ Ranking: index + 1, ...ele }))
          .filter((t) => t["Transactions"] !== 0);
        // alert(JSON.stringify(finalRevData));
        report = {
          list: finalRevData,
        };

        summarytier = [makeCategorySummary(report.list)];
        summaryThreeValues.push([
          "Total",
          "Transactions: " + summarytier[0]["Transactions"],
          "Price (THB): " + summarytier[0]["Total Price (THB)"],
          "Quantity (Units): " + summarytier[0]["Quantity (units)"],
        ]);

        report.list.forEach((data, index) => {
          if (index >= 3) return null;
          summaryThreeValues.push([
            `${index + 1}. ${data["Category name"]}`,
            `Transactions: ${data["Transactions"]}`,
            `Price (THB): ${data["Total Price (THB)"]}`,
            `Quantity (Units): ${data["Quantity (units)"]}`,
          ]);
        });
        if (summaryThreeValues.length < 3) {
          const existingDataLength = summaryThreeValues.length;
          for (let i = 0; i < 4 - existingDataLength; i++) {
            summaryThreeValues.push([
              ` - `,
              `Transactions: 0`,
              `Price (THB): 0`,
              `Quantity (Units): 0`,
            ]);
          }
        }
      } else if (type === "Bigspender" || type === "Frequent") {
        const [members] = await getMembers({ fromDate, toDate, periodType });
        let fromAllDate = moment().subtract(100, "years").format("YYYY-MM-DD");
        let toAllDate = moment().format("YYYY-MM-DD");
        const [allMembers] = await getMembers({
          fromDate: fromAllDate,
          toDate: toAllDate,
          periodType: "All",
          allBranch: true,
        });

        let filterdMember, membersData;
        if (type === "Bigspender") {
          const [bigSpenders] = await getBigSpenders({ toDate });

          filterdMember = filterEmptyPayment(
            members?.map((m) => {
              const found = allMembers?.find(
                (a) => a.member_id === m.member_id
              );
              if (found) {
                return { ...m, ltv: found.payment.total_revenue };
              } else return { ...m, ltv: 0 };
            })
          );
          filterdMember = filterdMember
            ?.filter((member) =>
              bigSpenders.some((b) => b.phone === member.phone)
            )
            .filter((m) => m.payment?.total_transaction);
          membersData = mapTopBigspenderReport(filterdMember);
          membersData.sort(
            (a, b) => b["Total Revenue (THB)"] - a["Total Revenue (THB)"]
          );
        } else if (type === "Frequent") {
          const [frequentMembers] = await getFrequentMembers({ toDate });

          filterdMember = filterEmptyPayment(
            members?.map((m) => {
              const found = allMembers?.find(
                (a) => a.member_id === m.member_id
              );
              if (found) {
                return {
                  ...m,
                  ltv: found.payment.total_revenue,
                  lifetime_trans: found.payment.total_transaction,
                };
              } else return { ...m, ltv: 0, lifetime_trans: 0 };
            })
          );
          filterdMember = filterdMember
            ?.filter((member) =>
              frequentMembers.some((f) => member.phone === f.phone)
            )
            .filter((m) => m.payment?.total_transaction);
          membersData = mapTopBigspenderReport(filterdMember); //Can use both
          membersData.sort((a, b) => b["Trans"] - a["Trans"]);
        }

        //Find most frequent
        const mostFreqItemList = filterdMember?.map((member) => ({
          name: member.life_time.top_frequent_product?.name,
          frequent: member.life_time.top_frequent_product?.frequent,
          qty: member.life_time.top_frequent_product?.qty,
          amount: member.life_time.top_frequent_product?.amount,
        }));
        const tempItemList = [];

        mostFreqItemList?.forEach((item) => {
          const temp = tempItemList.find((t) => t.name === item.name);
          if (temp) {
            temp.frequent += item.frequent;
            temp.qty += item.qty;
            temp.amount += item.amount;
          } else {
            tempItemList.push(item);
          }
        });
        let mostFrequentNum = -1;
        let mostFrequentItemName = "";
        let mostFrequentItemValue = "";
        tempItemList?.forEach((i) => {
          if (i.frequent > mostFrequentNum) {
            mostFrequentNum = i.frequent;
            mostFrequentItemName = i.name;
            mostFrequentItemValue = i.amount;
          }
        });

        report = {
          list: membersData.map((m, index) => ({ Rank: index + 1, ...m })),
        };
        summarytier = [makeTopBigspenderSummary(report.list)];
        summary["Members"] = report.list.length;
        summary["LTV (THB)"] = summarytier[0]["LTV(THB)"];
        summary["Total Revenue (THB)"] = summarytier[0]["Total Revenue (THB)"];
        summary["Transactions"] = summarytier[0]["Trans"];
        summaryTwoValues.push([
          mostFrequentItemName + " (Frequent)",
          "Freq. " + (mostFrequentNum === -1 ? "-" : mostFrequentNum),
          "Value " + mostFrequentItemValue,
        ]);
        // summary["Total Transactions"] = summarytier[0]["Total Revenue"];
      } else alert(type);

      setRenderDatawithFilter({
        report,
        summary: summary,
        summarytier,
        summaryTwoValues,
        summaryThreeValues,
      });
    };

    manageFilter();
    if (pageCatType === "revenue") fetchAllRevenue();
    if (pageCatType === "customer") fetchAllMember();
    if (pageCatType === "loyalty") fetchAllLoyalty();
    if (pageCatType === "product") fetchAllProduct();
    if (pageCatType === "ranking") fetchAllRanking();
    if (pageCatType === "each-loyalty") fetchEachLoyalty();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filter,
    dateRange,
    selectedProduct,
    selectedTier,
    selectedCategory,
    selectedMemberType,
    selectedSortby,
    selectedTierSortby,
    selectedMemberSortby,
    selectedSubcategory,
  ]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const classes = useStyles();
  const ComponentToPrint = React.forwardRef((_, ref) => (
    <Box style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box
        style={{
          paddingLeft: 30,
          boxSizing: "border-box",
        }}
      >
        <SfBreadcrumbs path={"Business Insight/" + pageName} lower />
      </Box>
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "400px auto 400px 50px 50px",
        }}
      >
        <Typography variant="caption" className={classes.Typography} noWrap>
          {pageName}
        </Typography>
        <Box></Box>
        <SuperFilterList
          filtersUsed={filtersUsed}
          selectedFilter={filter}
          onSetFilter={setFilter}
          onSetDateRange={setDateRange}
          dateRange={dateRange}
          filterList={getCalendarFilter(pageCatType, type)}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          selectedTier={selectedTier}
          setSelectedTier={setSelectedTier}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedSubcategory={selectedSubcategory}
          setSelectedSubcategory={setSelectedSubcategory}
          selectedMemberType={selectedMemberType}
          setSelectedMemberType={setSelectedMemberType}
          selectedSortby={selectedSortby}
          setSelectedSortby={setSelectedSortby}
          selectedTierSortby={selectedTierSortby}
          setSelectedTierSortby={setSelectedTierSortby}
          selectedMemberSortby={selectedMemberSortby}
          setSelectedMemberSortby={setSelectedMemberSortby}
        />{" "}
        {allLoadedData && (
          <ActionBar
            handlePrint={handlePrint}
            dataExportExcel={allLoadedData}
            pageName={pageName}
          />
        )}
      </Box>

      <Grid
        item
        xs={12}
        style={{
          paddingLeft: 30,
          boxSizing: "border-box",
          minHeight: 100,
          maxHeight: 100,
          height: 100,
        }}
      >
        {renderData && (
          <CardTotal
            type="single"
            value={renderData.summary}
            twoValues={renderData.summaryTwoValues}
            threeValues={renderData.summaryThreeValues}
            summaryBoxes={renderData.summaryBoxes}
            tierBox={renderData.tierBox}
          />
        )}
      </Grid>
      {/* <Box className={classes.pageButtonContainer}>
        <Button onClick={() => setPage(page - 1)}>Prev</Button>
        <Typography>{page + 1}</Typography>
        <Button onClick={() => setPage(page + 1)}>Next</Button>
      </Box> */}
      <Grid
        item
        xs={12}
        style={{ paddingLeft: 12, boxSizing: "border-box", flexBasis: "auto" }}
      >
        {renderData && (
          <Table
            data={renderData}
            page={page}
            setPage={setPage}
            allRows={allLoadedData?.list?.length ?? 0}
            rowPerPage={10}
          />
        )}
      </Grid>
      {<TableforPrint ref={ref} data={renderData} pageTitle={pageName} />}
      <PermissionChecker code="Page.Merchant.Business_Insight" />
    </Box>
  ));

  // const PrintOnlyTable = React.forwardRef((_, ref) => (
  //   <Box ref={ref}> {renderData && <Table data={renderData} />}</Box>
  // ));
  return (
    <Box className={classes.root}>
      <DrawerComponent onReport />
      <ComponentToPrint ref={componentRef} />
    </Box>
  );
}

const sortbyDate = (datas, periodType = "Day") => {
  datas.sort((a, b) => new Date(b["Date"]) - new Date(a["Date"]));
  return datas.map((data) => {
    const dateTime = getDateTimeFormat(new Date(data["Date"]), periodType);
    delete data["Date"]; //Put in front of it
    return {
      Date: dateTime,
      ...data,
    };
  });
};


const getNumUniqueMember = (datas) => {
  //const uniqueValuesSet = new Set();

  // let filteredUniqueUser = datas
  //   .filter((obj) => {
  //     // check if name property value is already in the set
  //     const isPresentInSet = uniqueValuesSet.has(obj["Name"]);
  //     // add name property value to Set
  //     uniqueValuesSet.add(obj["Name"]);
  //     // return the negated value of
  //     // isPresentInSet variable
  //     return !isPresentInSet;
  //   })
  //   .filter((data) => data["Name"] !== "Walk-in");

  let   filteredUniqueUser = datas.filter((data) => data["Name"] !== "Walk-in");
  return filteredUniqueUser.length;
};

const mapMerchantName = async (datas, fieldName) => {
  //TOO lazy for promise all
  //Super simple cache
  let loadedId = null,
    loadedName = null;
  for (let i = 0; i < datas.length; i++) {
    if (datas[i][fieldName] === loadedId) {
      datas[i][fieldName] = loadedName;
    } else {
      const [result, error] = await loadOneUser(datas[i][fieldName]);

      if (result) {
        loadedId = datas[i][fieldName];
        datas[i][fieldName] = result.firstname + " " + result.lastname;
        loadedName = datas[i][fieldName];
      } else if (error) {
        datas[i][fieldName] = "Can't load name";
      } else {
        datas[i][fieldName] = "Can't load name";
      }
    }
  }
  return [...datas];
};

const getCalendarFilter = (catType, type) => {

  switch(catType){
    case "ranking": {
      switch(type) {
        case 'Product':
        return ["All", "Day", "Month", "Year", "Custom Date"]
       
        default :
        return ["All", "Day", "Month", "Year"];
      }
     
    }
    default :
     return ["All", "Day", "Month", "Year"];
  }
}

const getUseFilters = (catType, type) => {
  let result;
  switch (catType) {
    case "revenue": {
      switch (type) {
        case "Member":
          result = ["calendar", "memberSortby"];
          break;
        case "All":
        case "Transactions":
        default:
          result = ["calendar"];
          break;
      }
      break;
    }
    case "customer": {
      switch (type) {
        case "Member": {
          result = ["tier", "calendar"];
          break;
        }
        case "Guest":
          result = ["calendar"];
          break;
        case "All":
          result = ["calendar"];
          break;
        case "Bigspender":
          result = ["tier", "calendar"];
          break;
        case "Frequent":
          result = ["tier", "calendar"];
          break;
        default:
          result = ["calendar"];
          break;
      }

      break;
    }
    case "loyalty": {
      switch (type) {
        case "Tiers": {
          result = ["tiersortby"];
          break;
        }
        case "Remaining":
          result = ["tier"];
          break;
        case "Total":
        case "Redeem":
        default:
          result = ["tier", "calendar"];
          break;
      }
      break;
    }
    case "product": {
      switch (type) {
        case "Product":
          result = ["member", "product", "calendar"];
          break;
        case "Category":
          result = ["member", "category", "calendar"];
          break;
        case "Subcategory":
          result = ["member", "subcategory", "calendar"];
          break;
        default:
          result = ["calendar"];
          break;
      }
      break;
    }
    case "ranking": {
      switch (type) {
        case "Product":
        case "Category": {
          result = ["calendar", "sortby", "member"];
          break;
        }
        case "Payment":
        case "Bigspender":
        case "Frequent":
        default:
          result = ["calendar"];
          break;
      }
      break;
    }
    case "each-loyalty": {
      result = [];
      break;
    }
    default: {
      result = [];
      break;
    }
  }

  return result;
};

const filterEmptyPayment = (datas) => {
  if (!datas) return [];
  return datas.filter(
    (d) =>
      !(
        d.payment && // 👈 null and undefined check
        Object.keys(d.payment).length === 0 &&
        d.payment.constructor === Object
      )
  );
};

const sortByName = (datas, periodType) => {
  return datas
    .sort((a, b) => {
      if (a.Name > b.Name) {
        return 1;
      }
      if (b.Name > a.Name) {
        return -1;
      }
      return 0;
    })
    .map((data) => {
      const dateTime = getDateTimeFormat(new Date(data["Date"]), periodType);
      delete data["Date"]; //Put in front of it
      return {
        Date: dateTime,
        ...data,
      };
    });
};
const sortByItem = (datas, periodType) => {
  return datas
    .sort((a, b) => {
      if (a["Quantity (Units)"] > b["Quantity (Units)"]) {
        return -1;
      }
      if (b["Quantity (Units)"] > a["Quantity (Units)"]) {
        return 1;
      }
      return 0;
    })
    .map((data) => {
      const dateTime = getDateTimeFormat(new Date(data["Date"]), periodType);
      delete data["Date"]; //Put in front of it
      return {
        Date: dateTime,
        ...data,
      };
    });
};
const sortByRevenue = (datas, periodType) => {
  return datas
    .sort((a, b) => {
      if (a["Total Revenue"] > b["Total Revenue"]) {
        return -1;
      }
      if (b["Total Revenue"] > a["Total Revenue"]) {
        return 1;
      }
      return 0;
    })
    .map((data) => {
      const dateTime = getDateTimeFormat(new Date(data["Date"]), periodType);
      delete data["Date"]; //Put in front of it
      return {
        Date: dateTime,
        ...data,
      };
    });
};
export default GeneralRevenue;
